module.exports = __webpack_public_path__ + "img/localUpload.d5b8845e.svg";